import { QueryFetchResponse, request as requester, useQueryFetch } from 'sonata-react-components';

import { MediaInfo } from '@/components/common/AdvertiserCampaignSelector/types';

export const generateNewMediaAdvertiser = (data: any) => {
  return requester.makeRequest(`${taptap.config.sonataBackendUrl}mediaInfo/userAdvertiser`, {
    data,
    method: 'POST'
  });
};

export const getMediaInfoDictionaries = () => {
  return requester.makeRequest(`${taptap.config.sonataBackendUrl}mediaInfo/`, {
    method: 'GET'
  });
};

export function useFetchMediaInfoDictionaries(): QueryFetchResponse<MediaInfo[]> {
  const cacheKey = 'media-info-dictionaries';
  return useQueryFetch<MediaInfo[]>(cacheKey, async () => getMediaInfoDictionaries());
}

export const uploadImage = (raw: any, userId: string) => {
  return requester.makeRequest(`${taptap.config.sonataBackendUrl}image/${userId}`, {
    data: new Blob([raw]),
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'POST',
    params: {
      name: raw.name
    }
  });
};

export const uploadMediaAdvertiserLogo = (mediaAdvertiserId: string, image: any) => {
  return requester.makeRequest(`${taptap.config.sonataBackendUrl}mediaInfo/userAdvertiser/${mediaAdvertiserId}/logo`, {
    data: {
      image
    },
    method: 'POST'
  });
};

export const deleteMediaAdvertiserLogo = (mediaAdvertiserId: string) => {
  return requester.makeRequest(`${taptap.config.sonataBackendUrl}mediaInfo/userAdvertiser/${mediaAdvertiserId}/logo`, {
    method: 'DELETE'
  });
};
